import cn from "classnames";
import PanelTemplate from "components/shared/profile/panel";
import { featureModuleTypesEnum, organizationDocumentsPolicysEnum } from "helpers/enums";
import { formatInitial } from "helpers/form";
import { numberInRange } from "helpers/validators";
import React, { Fragment } from "react";
import { editAccountant } from "sources/profile/organization";
import OrgLogo from "../orgLogo";
import { config, initialState } from "./config";
import Management from "./management";

class PersonalInfo extends PanelTemplate {
    componentDidMount() {
        const { data, initialState } = this.props;
        const initialData = formatInitial(data, initialState);
        if (initialData.location === "") {
            initialData.location = null;
        }
        if (data) {
            this.setState({ data: initialData });
        }
    }

    renderBody = () => {
        const { editable, config, organization, availableFeatureModules, modal } = this.props;
        const {
            name,
            email,
            phoneNumber,
            site,
            address,
            timezoneId,
            isDriverGeozoneControlEnabled,
            driverMustBeAtPointForAction,
            driverGeozoneActionWindow,
            closedPeriodDay,
            closedPeriodIsEnabled,
            useClosedPeriodByDate,
            closedPeriodDate,
            criticalMileage,
            bidPointVisitIgnoreDuration,
            customPointVisitIgnoreDuration,
            usesBidsApproval,
            geozoneRadius,
            itemChangePointGeozoneRadius,
            driverAtPointOffset,
            wantedOutput,
            minimumCarStopDuration,
            minimumRefuelingDuration,
            maxPlanMileageDeviation,
            startBidWithSuccessSync,
            startEmptyMileageBidWithoutSync,
            techSupportNumber,
            sendMobileAppCoordinates,
            sendCoordinatesGap,
            saveCoordinatesInterval,
            useOdometerMileage,
            minimumBidItemChangePointDuration,
            suppressRefuelingUpdateRadius,
            displayPlanLeaveDate,
            weightLimit,
            showBidParticipantsFilterSeparately,
            showAllDraftsInPlanning,
            useUniqueUsersGroups,
            disableEnvelopeUniquenessChecking,
            distributedBidRequired,
            documentsPolicy,
            doNotNotifyDriversAboutBidRefuelingsUpdated,
        } = config;
        const addressValue = this.state.data.address;

        const startBidWithSuccessSyncChange = ({ value, name }) => {
            const data = { ...this.state.data, [name]: value };
            if (!value) {
                data.startEmptyMileageBidWithoutSync = false;
            }
            const shouldUpdate = this.compareStateAndProps(this.props.data, data);
            const isValid = this.isValidForm(data);
            this.setState({ data, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
        };

        const driverMustBeAtPointForActionChange = ({ value, name }) => {
            const data = { ...this.state.data, [name]: value };
            if (!value) {
                data.driverGeozoneActionWindow = null;
            }
            const shouldUpdate = this.compareStateAndProps(this.props.data, data);
            const isValid = this.isValidForm(data);
            this.setState({ data, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
        };

        const { pinCode } = this.state.data;
        const hasUniversalTransferDocumentsPolicy =
            this.state.data.documentsPolicy === organizationDocumentsPolicysEnum.WithUniversalTransferDocuments ||
            this.state.data.documentsPolicy === 1;
        const documentsPolicyChange = ({ name, value }) => {
            this.setValue({
                name,
                value: value
                    ? organizationDocumentsPolicysEnum.WithUniversalTransferDocuments
                    : organizationDocumentsPolicysEnum.None,
            });
        };

        return (
            <>
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Общая информация</h5>
                    </div>
                    <div className="col-sm-8">
                        {this.renderField({ ...name, disabled: !editable })}
                        <OrgLogo modal={modal} />
                        <div className="field-wrap--value row mb-2">
                            <label className="col-form-label col-form-label-sm col-12 text-muted">Пин-код</label>
                            <div className="col-12">{pinCode ?? "—"}</div>
                        </div>
                        {this.renderField({ ...email, disabled: !editable })}
                        {this.renderField({ ...phoneNumber, disabled: !editable })}
                        {this.renderField({ ...site, disabled: !editable })}
                        {this.renderAddressField({
                            ...address,
                            disabled: !editable,
                            geopoint: { address: addressValue },
                        })}
                        {this.renderSelect({ ...timezoneId, disabled: !editable })}
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Настройки геозон</h5>
                    </div>
                    <div className="col-sm-8">
                        {this.renderField({ ...bidPointVisitIgnoreDuration, disabled: !editable })}
                        {this.renderField({ ...customPointVisitIgnoreDuration, disabled: !editable })}
                        {this.renderField({ ...geozoneRadius, disabled: !editable })}
                        {this.renderField({ ...itemChangePointGeozoneRadius, disabled: !editable })}
                        {this.renderField({ ...driverAtPointOffset, disabled: !editable })}
                        {this.renderField({ ...minimumBidItemChangePointDuration, disabled: !editable })}
                        {this.renderField({ ...minimumRefuelingDuration, disabled: !editable })}
                        {this.renderField({ ...maxPlanMileageDeviation, disabled: !editable })}
                        {this.renderCheckbox({ ...sendMobileAppCoordinates, disabled: !editable })}
                        {this.renderCheckbox({ ...isDriverGeozoneControlEnabled, disabled: !editable })}
                        {this.renderCheckbox({
                            ...driverMustBeAtPointForAction,
                            disabled: !editable,
                            onChange: driverMustBeAtPointForActionChange,
                        })}
                        {this.renderField({
                            ...driverGeozoneActionWindow,
                            disabled: !this.state.data.driverMustBeAtPointForAction || !editable,
                        })}
                        <Fragment key={this.state.data.sendMobileAppCoordinates}>
                            {this.renderField({
                                ...sendCoordinatesGap,
                                validators: [
                                    (value) =>
                                        this.state.data.sendMobileAppCoordinates ? numberInRange(value, 30, 720) : "",
                                ],

                                disabled: !this.state.data.sendMobileAppCoordinates || !editable,
                            })}
                            {this.renderField({
                                ...saveCoordinatesInterval,
                                validators: [
                                    (value) =>
                                        this.state.data.sendMobileAppCoordinates ? numberInRange(value, 1, 20) : "",
                                ],

                                disabled: !this.state.data.sendMobileAppCoordinates || !editable,
                            })}
                        </Fragment>
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Прочие настройки</h5>
                    </div>
                    <div className="col-sm-8">
                        {this.renderCheckbox({ ...closedPeriodIsEnabled, disabled: !editable })}
                        {this.renderSelect({
                            ...useClosedPeriodByDate,
                            disabled: !this.state.data.closedPeriodIsEnabled || !editable,
                            value: String(this.state.data.useClosedPeriodByDate),
                            onChange: ({ name, value }) => this.setValue({ name, value: value === "true" }),
                        })}
                        {this.state.data.useClosedPeriodByDate
                            ? this.renderField({
                                  ...closedPeriodDate,
                                  type: "date",
                                  disabled: !this.state.data.closedPeriodIsEnabled || !editable,
                              })
                            : this.renderField({
                                  ...closedPeriodDay,
                                  type: "dayNumber",
                                  disabled: !this.state.data.closedPeriodIsEnabled || !editable,
                              })}
                        {this.renderField({ ...criticalMileage, disabled: !editable })}
                        {this.renderField({
                            ...wantedOutput,
                            disabled: !editable,
                            label: `Желаемая выработка одной машины (${organization?.currencyData?.name}/км)`,
                        })}
                        {this.renderField({ ...minimumCarStopDuration, disabled: !editable })}
                        {this.renderField({ ...suppressRefuelingUpdateRadius, disabled: !editable })}
                        {this.renderField({ ...techSupportNumber, disabled: !editable })}
                        {this.renderCheckbox({
                            ...startBidWithSuccessSync,
                            disabled: !editable,
                            onChange: startBidWithSuccessSyncChange,
                        })}
                        {this.renderCheckbox({
                            ...startEmptyMileageBidWithoutSync,
                            disabled: !this.state.data.startBidWithSuccessSync || !editable,
                        })}
                        {this.renderCheckbox({ ...usesBidsApproval, disabled: !editable })}
                        {this.renderCheckbox({ ...displayPlanLeaveDate, disabled: !editable })}
                        {this.renderCheckbox({ ...weightLimit, disabled: !editable })}
                        {availableFeatureModules.includes(featureModuleTypesEnum.Exploitation) &&
                            this.renderCheckbox({ ...useOdometerMileage, disabled: !editable })}
                        {this.renderCheckbox({ ...showBidParticipantsFilterSeparately, disabled: !editable })}
                        {this.renderCheckbox({ ...showAllDraftsInPlanning, disabled: !editable })}
                        {this.renderCheckbox({ ...useUniqueUsersGroups, disabled: !editable })}
                        {availableFeatureModules.includes(featureModuleTypesEnum.DocumentAssignment) &&
                            this.renderCheckbox({ ...disableEnvelopeUniquenessChecking, disabled: !editable })}
                        {this.renderCheckbox({ ...distributedBidRequired, disabled: !editable })}
                        {this.renderCheckbox({
                            ...documentsPolicy,
                            disabled: !editable,
                            value: hasUniversalTransferDocumentsPolicy,
                            onChange: documentsPolicyChange,
                        })}
                        {this.renderCheckbox({ ...doNotNotifyDriversAboutBidRefuelingsUpdated, disabled: !editable })}
                    </div>
                </div>
            </>
        );
    };

    render() {
        const cname = cn("card card-body mb-3", {
            "border-danger book-form__body--invalid": !this.state.isValid,
        });
        const { management, accountant } = this.props.data;
        const { editable, update, organization, modal } = this.props;
        return (
            <>
                {this.props.availableFeatureModules.includes(featureModuleTypesEnum.CrStart) && (
                    <Management
                        data={accountant ?? {}}
                        management={management ?? {}}
                        editable={editable}
                        action={(accountant) => editAccountant({ id: organization.id, accountant })}
                        update={update}
                        modal={modal}
                    />
                )}
                <div className={cname}>
                    {this.renderBody()}
                    {this.renderButton()}
                </div>
            </>
        );
    }
}

function removeKeys(obj, keysToRemove) {
    if (Array.isArray(obj)) {
        return obj.map((item) => removeKeys(item, keysToRemove)).filter((item) => Object.keys(item).length > 0);
    } else if (typeof obj === "object" && obj !== null) {
        return Object.keys(obj).reduce((acc, key) => {
            if (!keysToRemove.includes(key)) {
                acc[key] = removeKeys(obj[key], keysToRemove);
            }
            return acc;
        }, {});
    }
    return obj;
}

const ConfiguredPanel = (props) => {
    const { mergeBidsParams, bids } = props;

    const action = (data) =>
        props.action(data).then((res) => {
            if (res) {
                mergeBidsParams({
                    ...bids.params,
                    customFilters: {
                        ...bids.params.customFilters,
                        logistId: undefined,
                        carLogistId: undefined,
                        responsibleId: undefined,
                        salesManagerId: undefined,
                    },
                    preparedFilter: {
                        ...removeKeys(bids.params.preparedFilter, ["carLogistId", "responsibleId", "salesManagerId"]),
                    },
                });
            }
            return res;
        });

    return <PersonalInfo {...props} action={action} config={config} initialState={initialState} />;
};

export default ConfiguredPanel;
